import { useState, useEffect } from "react";

// ═══════════════════════════════════════════════════════════════════════════
// MÓVIL — fuente única del corte entre móvil y escritorio (gemelo del portal).
//
// Con estilos en línea no hay media queries, así que el ancho se lee en el
// navegador y se escucha el redimensionado.
//
// REGLA: una pantalla que necesite saber si está en móvil usa useIsMobile(),
// nunca window.innerWidth suelto. El escritorio no cambia.
// ═══════════════════════════════════════════════════════════════════════════

export const MOBILE_BP = 900;

const isNarrow = (bp) => typeof window !== "undefined" && window.innerWidth < bp;

export function useIsMobile(bp = MOBILE_BP) {
  // CRA no renderiza en servidor: se puede leer el ancho desde el primer render
  // y así no hay un parpadeo de escritorio al abrir en el móvil.
  const [mobile, setMobile] = useState(() => isNarrow(bp));
  useEffect(() => {
    const check = () => setMobile(isNarrow(bp));
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [bp]);
  return mobile;
}

// Alto de las barras fijas del móvil (arriba y abajo): el contenido y los
// paneles a pantalla completa no deben quedar debajo.
export const MOBILE_TOP = 52;
export const MOBILE_BOTTOM = 64;
